import type {ReactNode} from 'react';
export type ReviewGroup={group?:string;groupLabel?:string};
/** One decision, grouped by capture. */
export default function ReviewGroups<T extends ReviewGroup>({items,render}:{items:T[];render:(item:T,index:number)=>ReactNode}){
 return <>{[...new Set(items.map(item=>item.group))].map(group=>{
  const rows=items.flatMap((item,index)=>item.group===group?[<li key={index}>{render(item,index)}</li>]:[]);
  return group?<details key={group}><summary>{items.find(item=>item.group===group)?.groupLabel??group}</summary><ul>{rows}</ul></details>:<ul key="ungrouped">{rows}</ul>;
 })}</>;
}
